import { SIDEBAR_ACTIVE_MUTATION } from '../mutation-types';

export const namespaced = true;

export const state = {
  namespaced: true,
    isActive: true,
};

export const actions = {    
};

export const mutations = {   
    [SIDEBAR_ACTIVE_MUTATION](state, isActive){
      state.isActive = isActive;
    }, 
};